import type {ModalDialogService} from 'shared/modal-dialogs';
import {exists} from 'shared/utils/custom-utils';

// Usable only on text inputs and text areas!
export function specialSymbolsKeyboard(node: HTMLInputElement | HTMLTextAreaElement, modalDialogService: ModalDialogService | undefined) {
    const keyDownHandler = (event: KeyboardEvent) => {
        if (!event.ctrlKey || event.key !== 'F7' || !exists(modalDialogService)) {
            return;
        }

        modalDialogService.openModalWindow('specialSymbolsKeyboard', {inputRef: node});
    }

    node.addEventListener('keydown', keyDownHandler);

    return {
        destroy() {
            node.removeEventListener('keydown', keyDownHandler);
        }
    }
}

export function createSpecialSymbolsKeyboardAction(modalDialogService: ModalDialogService | undefined) {
    return (node: HTMLInputElement | HTMLTextAreaElement) => specialSymbolsKeyboard(node, modalDialogService);
}